import { fetch } from 'wix-fetch';
const options = {
	method: 'GET',
	credentials: 'include',
	cache: 'no-store'
};
 
export async function allPageButtonsEvent() {
	try {
		let result = await fetch('https://frog.wix.com/potential-experts?src=80&evid=503', options);
	} catch (err) {
		console.error('Error: ', err);
	}
}


export async function submitButtonEvent(itemId, url, additionalInfo, buttonName, formDetails, topic) {
	try {
		let result = await fetch(`https://frog.wix.com/potential-experts?src=80&evid=501&additional_info=${additionalInfo}&button_name=${buttonName}&formDetailsJson=${formDetails}&formIsValid=true&full_url=${url}&leadId=${itemId}&topic=${topic}`, options);
	} catch (err) {
		console.error('Error: ', err);
	}
}